export default __webpack_public_path__ + "static/media/gas-sub-meter-icon.5745ae37.svg";